import arc from './quarter-arc.js'
import { path } from 'd3-path'
import pointer from './pointer.js'

export default function (dimensions, handles, baseBottom = dimensions.height, pointerHeight, pointerBounds) {
  const _path = path()

  const arrowHandle = handles[0]

  const _pointer = pointer(_path, dimensions, handles[0], {
    height: pointerHeight,
    width: dimensions.width * arrowHandle[0] * 2
  })

  const tipOffset =  _pointer.width / 2
  const outerRadius = dimensions.width - dimensions.width * handles[1][0]
  const innerRadius = Math.max(0, outerRadius - _pointer.width)

  // Start at the top center of the symbol
  _path.moveTo(dimensions.center[0], 0)

  // Move to the start of the right curve
  _path.lineTo(dimensions.width - outerRadius , 0)

  arc(_path, [dimensions.width - outerRadius, outerRadius], outerRadius, 3 * Math.PI / 2)

  _path.lineTo(dimensions.width, baseBottom)
  _path.lineTo(dimensions.width - _pointer.width, baseBottom)
  _path.lineTo(dimensions.width - _pointer.width, _pointer.width + innerRadius)

  arc(_path, [dimensions.width - _pointer.width - innerRadius, _pointer.width + innerRadius], innerRadius, 0, false)

  _path.lineTo(_pointer.width + tipOffset + innerRadius, _pointer.width)

  arc(_path, [_pointer.width + tipOffset + innerRadius, _pointer.width + innerRadius], innerRadius, 3 * Math.PI / 2, false)

  _pointer([_pointer.width + tipOffset, dimensions.height * arrowHandle[1]], 'south', pointerBounds)

  _path.lineTo(tipOffset, _pointer.width + innerRadius)

  arc(_path, [tipOffset + outerRadius, outerRadius], outerRadius, Math.PI)

  _path.lineTo(dimensions.center[0], 0)

  _path.closePath()

  return _path.toString()
}
